import React, { useState } from "react";
import { AiOutlineLoading } from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { IoCheckmark, IoClose } from "react-icons/io5";
import { MdError } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { _resetUploadFiles, _setShowUpload } from "../../../store/slices/global.slice";
import { useNavigate } from "react-router-dom";

const QueuePopup = ({ show = false }) => {
  const [isContentVisible, setContentVisible] = useState(true);
  const { uploadFiles } = useSelector((state) => state.global);

  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(_resetUploadFiles())
  }

  if (!show) return null; // Hide the entire popup when "close" is clicked

  return (
    <div className="fixed right-4 bottom-0 z-10 w-96 bg-white rounded-t-md border border-b-0 border-borderColor shadow-2xl text-theme">
      <div className="border-b border-borderColor h-12 flex items-center gap-2 justify-between px-4 bg-gray-300 rounded-t-md">
        <span className="flex flex-row gap-1 items-center text-cs font-semibold">
          <p>{uploadFiles?.length || 0}</p> Upload Complete
        </span>
        <span className="flex flex-row gap-1">
          <span
            onClick={() => setContentVisible(!isContentVisible)}
            className="cursor-pointer w-6 h-6 hover:bg-bghoverlight bg-primary-200 border border-borderColor hover:border-borderColor rounded-full items-center flex justify-center"
          >
            {isContentVisible ? <IoIosArrowDown /> : <IoIosArrowUp />}
          </span>
          <span
            onClick={() => closeModal(false)}
            className="cursor-pointer w-6 h-6 hover:bg-bghoverlight hover:border hover:border-borderColor hover:rounded-full items-center flex justify-center"
          >
            <IoClose />
          </span>
        </span>
      </div>
      {isContentVisible && (
        <div className="flex flex-col gap-2 p-4 max-h-60 overflow-y-scroll">
          {uploadFiles && uploadFiles.length ?
            uploadFiles.map((item, _index) => {
              return <FileCard key={_index} item={item} />
            }) :
            <div className="flex justify-between items-center ">
              No Files Found
            </div>}
        </div>
      )}
    </div>
  );
};

const FileCard = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { name, url, loading, success, failed } = item;

  const handleRedirect = () => {
    dispatch(_resetUploadFiles())
    navigate(url || "/");
  };

  const renderStatusIcon = () => {
    if (loading) {
      return <Loading />;
    }

    return success && !failed ? (
      <span className="rounded-full bg-success-500 w-6 h-6 flex items-center justify-center text-white">
        <IoCheckmark />
      </span>
    ) : (
      <span className="rounded-full bg-error-500 w-6 h-6 flex items-center justify-center text-white">
        <MdError />
      </span>
    );
  };

  return (
    <div className="flex justify-between items-center">
      <span
        onClick={handleRedirect}
        title={name || "Click to navigate"}
        className="text-cs cursor-pointer hover:underline w-60 truncate"
        role="button"
        tabIndex={0}
      >
        {name || "Unknown File"}
      </span>
      <span className="flex flex-row gap-2">
        {renderStatusIcon()}
      </span>
    </div>
  );
};

const Loading = () => {
  return (
    <div className={"flex justify-center "}>
      <div className="flex flex-col justify-center items-center gap-2">
        <AiOutlineLoading
          speed={1}
          className="animate-spin rounded-full
         text-theme"
        />
      </div>
    </div>
  );
};

export default QueuePopup;
